// As a last resort for tracking users across pages, you can include some
// searchable junk in a URL query parameter. To be really neat about it, it's
// nice to swipe it away from the user on the page you're linking to. You can
// use this to do that ... right out from under their nose.
export const removeLocationSearchParams = (...param_names: string[]) => {
  const params = new URLSearchParams(window.location.search);
  param_names.forEach((name) => params.delete(name));

  const href = new URL(window.location.href);
  href.search = params.toString();
  history.replaceState({}, document.title, href.toString());
};
